<template>
  <div class="media-upload">
    <progress-bar v-if="canEdit" :progress="progress"/>
    <transition name="fade" mode="out-in">
      <component v-if="!loading" :is="currentUploadComponent" @next="goNext" @back="goBack" @setState="setState" :viewonly="!canEdit" />
    </transition>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue'
import UploadPlatform from '@/views/UploadPlatform.vue'
import UploadHmi from '@/views/UploadHmi.vue'
import UploadName from '@/views/UploadName.vue'
import UploadDates from '@/views/UploadDates.vue'
import UploadDetails from '@/views/UploadDetails.vue'
import UploadReview from '@/views/UploadReview.vue'
import UploadDefault from '@/views/UploadDefault.vue'
import UploadDefaultCountry from '@/views/UploadDefaultCountry.vue'
import UploadDone from '@/views/UploadDone.vue'
import { LOAD_ACTIVE_MEDIA } from '@/store/actions.type'
import { RESET_ACTIVE_MEDIA } from '@/store/mutations.type'

export default {
  name: 'media-upload',
  components: {
    ProgressBar,
    UploadPlatform,
    UploadHmi,
    UploadName,
    UploadDates,
    UploadDetails,
    UploadReview,
    UploadDefault,
    UploadDefaultCountry,
    UploadDone
  },
  data() {
    return {
      state: 'platform',
      mediaID: null,
      loading: false,
      options: {}
    }
  },
  computed: {
    canEdit() {
      return this.$store.getters.canEdit
    },
    currentUploadComponent() {
      if (this.mediaID === 'default' && this.$route.params.page && this.$route.params.page !== 'done') {
        return 'upload-default-country'
      }
      return this.state ? ('upload-' + this.state.toLowerCase()) : null
    },
    progress() {
      switch (this.state) {
        case 'platform': return 1 / 7
        case 'hmi': return 2 / 7
        case 'name': return 3 / 7
        case 'dates': return 4 / 7
        case 'details': return 5 / 7
        case 'review': return 6 / 7
        case 'default': return 1 / 4
        case 'us': return 2 / 4
        case 'ca': return 3 / 4
        case 'done': return 1
        default: return 0
      }
    }
  },
  watch: {
    '$route.params.media': function(media) {
      this.mediaID = media
      if (media === 'create') this.$store.commit(RESET_ACTIVE_MEDIA)
      if (!this.$route.params.page) this.state = media === 'default' ? 'default' : 'platform'
    },
    '$route.params.page': function(page) {
      if (page) this.state = page
      else if (this.mediaID === 'default') this.state = 'default'
      else this.state = 'platform'
    },
    progress(value) {
      if (!value) this.$router.replace('/')
    }
  },
  methods: {
    setState(path) {
      if (path) {
        this.statePath = path;
      } else {
        this.statePath = ['hmi','name','dates','details','review'];
      }
    },
    goNext(state) {
      let newState = state
      if (!newState) {
        const index = this.statePath.indexOf(this.state)
        if (index + 1 >= this.statePath.length) newState = this.endState
        else newState = this.statePath[index + 1]
      }
      this.$router.push(`/media/${this.mediaID}/${newState}`)
    },
    goBack() {
      if (this.startState === 'platform') {
        this.$router.go('-1')
      } else if (this.mediaID === 'default' && this.$route.params.page) {
        this.$router.go('-1')
      } else if (this.mediaID === 'default') {
        this.$router.push('/media/create')
      } else if (this.statePath) {
        let newState = 'platform'
        const index = this.statePath.indexOf(this.state)
        if (index - 1 < 0) newState = 'platform'
        else newState = this.statePath[index - 1]
        this.$router.push(`/media/${this.mediaID}/${newState}`)
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.media === 'default' && to.params.page) {
      next('/media/default')
    } else {
      next()
    }
  },
  created() {
    this.endState = 'done'
    this.statePath = ['hmi','name','dates','details','review']
    this.mediaID = this.$route.params.media
    if (this.mediaID === 'default') {
      this.state = 'default'
    } else {
      let loadState = this.$route.params.page ? this.$route.params.page : 'platform'

      if (!this.canEdit) {
        loadState = 'review'
        this.$router.replace(`/media/${this.mediaID}/review`)
      }

      if (this.mediaID === 'create') {
        this.$store.commit(RESET_ACTIVE_MEDIA)
        this.state = loadState
      } else {
        this.loading = true
        const loader = this.$loading.show()
        this.$store.dispatch(LOAD_ACTIVE_MEDIA, this.mediaID)
        .finally(() => {
          this.state = loadState
          this.startState = loadState
          this.loading = false
          loader.hide()
        })
      }
    }
    this.startState = this.state
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.media-upload {
  text-align: center;

  /deep/ header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .flow-btn {
      text-align: left;
      flex: 0 0 20%;
    }

    .title {
      margin: auto;

      h1 {
        margin-bottom: em(7, 32);

        & + p {
          margin: 0;
        }
      }

      & + .flow-btn {
        text-align: right;
      }
    }
  }
}
</style>
